/**
 * 用户接口
 * 科大平台用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CompanyLoginVo from './CompanyLoginVo';




  /**
   * The LoginTokenVo model module.
   * @module token/model/LoginTokenVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>LoginTokenVo</code>.
   * @alias module:token/model/LoginTokenVo
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>LoginTokenVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:token/model/LoginTokenVo} obj Optional instance to populate.
   * @return {module:token/model/LoginTokenVo} The populated <code>LoginTokenVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'twoFactorStatus')) {
        obj['twoFactorStatus'] = ApiClient.convertToType(data['twoFactorStatus'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'phoneNum')) {
        obj['phoneNum'] = ApiClient.convertToType(data['phoneNum'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'nick')) {
        obj['nick'] = ApiClient.convertToType(data['nick'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'idNumber')) {
        obj['idNumber'] = ApiClient.convertToType(data['idNumber'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'avatarUrl')) {
        obj['avatarUrl'] = ApiClient.convertToType(data['avatarUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'gender')) {
        obj['gender'] = ApiClient.convertToType(data['gender'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'token')) {
        obj['token'] = ApiClient.convertToType(data['token'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'companyOrgList')) {
        obj['companyOrgList'] = ApiClient.convertToType(data['companyOrgList'], [CompanyLoginVo]);
      }
    }
    return obj;
  }

  /**
   * 用户id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 0学生1老师
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;
  /**
   * 1：开启双要素验证， 0或null不开启
   * @member {Integer} twoFactorStatus
   */
  exports.prototype['twoFactorStatus'] = undefined;
  /**
   * 手机号
   * @member {String} phoneNum
   */
  exports.prototype['phoneNum'] = undefined;
  /**
   * 姓名(昵称）
   * @member {String} nick
   */
  exports.prototype['nick'] = undefined;
  /**
   * 身份证号，若返回为空，则跳转到完善个人信息页面
   * @member {String} idNumber
   */
  exports.prototype['idNumber'] = undefined;
  /**
   * 头像
   * @member {String} avatarUrl
   */
  exports.prototype['avatarUrl'] = undefined;
  /**
   * 性别 0：未知、1：男、2：女
   * @member {Integer} gender
   */
  exports.prototype['gender'] = undefined;
  /**
   * token
   * @member {String} token
   */
  exports.prototype['token'] = undefined;
  /**
   * 所在公司组织信息
   * @member {Array.<module:token/model/CompanyLoginVo>} companyOrgList
   */
  exports.prototype['companyOrgList'] = undefined;



  export default exports;
;


